import React from 'react';
import './error.scss';
import logo from '../../assets/msw-logo.png';

// Define the props interface
interface ErrorProps {
    message: string;
}

const Error: React.FC<ErrorProps> = ({ message }) => {
    return (
        <div className='rty'>
            <div className='error'>
                <p className='message'>
                    <i className='fa fa-exclamation-triangle'></i>
                    <span>{message}</span>
                </p>
                <div className='logo'>
                    <img src={logo} alt='logo' />
                    <div className='title'>
                        <p>Centralized <span>Access</span></p>
                        <p>Management <span>Program</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Error;
